const uploadFile = {
  state: {
    uploadFilestatus: false,
    uploadFileInfo: {}
  },
  mutations: {
    SET_Upload_Status: (state, routers) => {
      state.uploadFilestatus = routers
    },
    SET_Upload_Info: (state, routers) => {
      state.uploadFileInfo = routers
    }
  },
  actions: {

  }
}

export default uploadFile